// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nft-gallery-card {
    background-color: var(--bg-white);
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);
    overflow: hidden;
    margin-bottom: 24px;
    transition: all 0.3s ease;
  }

  .nft-gallery-card:hover {
    box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);
  }

  .nft-gallery-header {
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.06) 0%, rgba(95, 184, 165, 0.06) 100%);
    padding: 18px 24px;
    border-bottom: 2px solid var(--border-gray);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .nft-gallery-header h3 {
    margin: 0;
    color: var(--primary-teal);
    font-size: 1.25rem;
    font-weight: 600;
  }

  .nft-gallery-refresh {
    background: none;
    border: none;
    color: var(--text-medium);
    font-size: 1.3rem;
    cursor: pointer;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
  }

  .nft-gallery-refresh:hover {
    background-color: rgba(17, 69, 77, 0.08);
    color: var(--primary-teal);
    transform: rotate(90deg);
  }

  .nft-gallery-body {
    padding: 24px;
  }

  .nft-gallery-loading,
  .nft-gallery-error,
  .nft-gallery-empty {
    padding: 24px 0;
    text-align: center;
    color: var(--text-medium);
  }

  .nft-gallery-loading {
    position: relative;
    padding-bottom: 48px;
  }

  .nft-gallery-loading::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 24px;
    height: 24px;
    border: 2px solid var(--border-gray);
    border-top-color: var(--primary-teal);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .nft-gallery-error {
    color: var(--error);
  }

  .nft-gallery-retry {
    background-color: var(--primary-teal);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 0.95rem;
    margin-top: 12px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);
  }

  .nft-gallery-retry:hover {
    background-color: var(--primary-teal-light);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);
  }

  .nft-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 20px;
  }

  .nft-item {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(17, 69, 77, 0.1);
    transition: all 0.3s ease;
    background-color: var(--bg-white);
  }

  .nft-item:hover {
    transform: translateY(-6px);
    box-shadow: 0 8px 20px rgba(17, 69, 77, 0.2);
  }

  .nft-thumbnail {
    width: 100%;
    aspect-ratio: 1;
    background-color: var(--bg-cream);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nft-placeholder {
    font-size: 1.3rem;
    font-weight: bold;
    color: var(--text-light);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.05) 0%, rgba(95, 184, 165, 0.08) 100%);
  }

  .nft-info {
    padding: 14px;
    background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);
  }

  .nft-name {
    font-weight: 600;
    font-size: 0.95rem;
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--primary-teal);
  }

  .nft-mint {
    font-size: 0.8rem;
    color: var(--text-medium);
    font-family: 'Monaco', 'Menlo', monospace;
  }

  @keyframes spin {
    to {
      transform: translateX(-50%) rotate(360deg);
    }
  }

  @media (max-width: 600px) {
    .nft-grid {
      grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
      gap: 16px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/NFTGallery.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,6CAA6C;IAC7C,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,6FAA6F;IAC7F,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,wCAAwC;IACxC,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,2CAA2C;IAC3C,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;IAC5C,yBAAyB;IACzB,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,6FAA6F;EAC/F;;EAEA;IACE,aAAa;IACb,6FAA6F;EAC/F;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,yCAAyC;EAC3C;;EAEA;IACE;MACE,0CAA0C;IAC5C;EACF;;EAEA;IACE;MACE,4DAA4D;MAC5D,SAAS;IACX;EACF","sourcesContent":[".nft-gallery-card {\n    background-color: var(--bg-white);\n    border-radius: 16px;\n    box-shadow: 0 4px 16px rgba(17, 69, 77, 0.08);\n    overflow: hidden;\n    margin-bottom: 24px;\n    transition: all 0.3s ease;\n  }\n\n  .nft-gallery-card:hover {\n    box-shadow: 0 8px 24px rgba(17, 69, 77, 0.12);\n  }\n\n  .nft-gallery-header {\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.06) 0%, rgba(95, 184, 165, 0.06) 100%);\n    padding: 18px 24px;\n    border-bottom: 2px solid var(--border-gray);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .nft-gallery-header h3 {\n    margin: 0;\n    color: var(--primary-teal);\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n\n  .nft-gallery-refresh {\n    background: none;\n    border: none;\n    color: var(--text-medium);\n    font-size: 1.3rem;\n    cursor: pointer;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: all 0.3s ease;\n  }\n\n  .nft-gallery-refresh:hover {\n    background-color: rgba(17, 69, 77, 0.08);\n    color: var(--primary-teal);\n    transform: rotate(90deg);\n  }\n\n  .nft-gallery-body {\n    padding: 24px;\n  }\n\n  .nft-gallery-loading,\n  .nft-gallery-error,\n  .nft-gallery-empty {\n    padding: 24px 0;\n    text-align: center;\n    color: var(--text-medium);\n  }\n\n  .nft-gallery-loading {\n    position: relative;\n    padding-bottom: 48px;\n  }\n\n  .nft-gallery-loading::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n    transform: translateX(-50%);\n    width: 24px;\n    height: 24px;\n    border: 2px solid var(--border-gray);\n    border-top-color: var(--primary-teal);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n\n  .nft-gallery-error {\n    color: var(--error);\n  }\n\n  .nft-gallery-retry {\n    background-color: var(--primary-teal);\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 0.95rem;\n    margin-top: 12px;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);\n  }\n\n  .nft-gallery-retry:hover {\n    background-color: var(--primary-teal-light);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);\n  }\n\n  .nft-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 20px;\n  }\n\n  .nft-item {\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(17, 69, 77, 0.1);\n    transition: all 0.3s ease;\n    background-color: var(--bg-white);\n  }\n\n  .nft-item:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 8px 20px rgba(17, 69, 77, 0.2);\n  }\n\n  .nft-thumbnail {\n    width: 100%;\n    aspect-ratio: 1;\n    background-color: var(--bg-cream);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .nft-placeholder {\n    font-size: 1.3rem;\n    font-weight: bold;\n    color: var(--text-light);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.05) 0%, rgba(95, 184, 165, 0.08) 100%);\n  }\n\n  .nft-info {\n    padding: 14px;\n    background: linear-gradient(135deg, rgba(17, 69, 77, 0.02) 0%, rgba(95, 184, 165, 0.02) 100%);\n  }\n\n  .nft-name {\n    font-weight: 600;\n    font-size: 0.95rem;\n    margin-bottom: 6px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--primary-teal);\n  }\n\n  .nft-mint {\n    font-size: 0.8rem;\n    color: var(--text-medium);\n    font-family: 'Monaco', 'Menlo', monospace;\n  }\n\n  @keyframes spin {\n    to {\n      transform: translateX(-50%) rotate(360deg);\n    }\n  }\n\n  @media (max-width: 600px) {\n    .nft-grid {\n      grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n      gap: 16px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
